import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ConfirmModal from '../../ConfirmModal';
import '../FeedbackHistory.scss';
var shorten = function shorten(text) {
  return text.length > 56 ? "".concat(text.slice(0, 56), "...") : text;
};
var editableStatuses = ['Interviewed', 'Hired', 'Declined'];
var FeedbackHistoryRow = /*#__PURE__*/function (_Component) {
  function FeedbackHistoryRow() {
    _classCallCheck(this, FeedbackHistoryRow);
    return _callSuper(this, FeedbackHistoryRow, arguments);
  }
  _inherits(FeedbackHistoryRow, _Component);
  return _createClass(FeedbackHistoryRow, [{
    key: "renderEdit",
    value: function renderEdit() {
      var _this$props = this.props,
        item = _this$props.item,
        proposalResourceId = _this$props.proposalResourceId,
        csrfToken = _this$props.csrfToken,
        consultant = _this$props.consultant,
        reasonOptions = _this$props.reasonOptions,
        type = _this$props.type;
      return /*#__PURE__*/React.createElement(ConfirmModal, {
        proposalResourceId: proposalResourceId,
        csrfToken: csrfToken,
        consultantName: consultant.name,
        type: type,
        reasonOptions: reasonOptions,
        modalTriggerCopy: "Edit",
        modalTriggerType: "button",
        buttonType: "btn-secondary",
        statusChangeId: item.id,
        isEditing: true
      });
    }
  }, {
    key: "renderViewClorify",
    value: function renderViewClorify() {
      var clorifyUrl = this.props.clorifyUrl;
      return /*#__PURE__*/React.createElement("a", {
        role: "button",
        target: "_blank",
        tabIndex: 0,
        id: "view-clorify-button",
        href: clorifyUrl,
        rel: "noreferrer"
      }, "View Clorify");
    }
  }, {
    key: "renderStatus",
    value: function renderStatus() {
      var status = this.props.status;
      return /*#__PURE__*/React.createElement("div", {
        className: "rounded-rectangle status-".concat(status.split(' ').join('_').toLowerCase())
      }, /*#__PURE__*/React.createElement("div", {
        className: "status"
      }, status));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        item = _this$props2.item,
        status = _this$props2.status,
        internalFeedbackText = _this$props2.internalFeedbackText,
        advisorRemark = _this$props2.advisorRemark;
      var text;
      if (status === 'Submitted' && advisorRemark) {
        text = shorten(advisorRemark);
      } else if (item.change_reason) {
        text = shorten(item.change_reason);
      } else if (status === 'Drafting' && internalFeedbackText) {
        text = shorten(internalFeedbackText);
      } else {
        text = '';
      }
      return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        colSpan: "4"
      }, text), /*#__PURE__*/React.createElement("td", {
        colSpan: "2"
      }, this.renderStatus()), /*#__PURE__*/React.createElement("td", {
        colSpan: "2"
      }, item.user_name), /*#__PURE__*/React.createElement("td", {
        colSpan: "2"
      }, item.created_at), /*#__PURE__*/React.createElement("td", {
        colSpan: "2"
      }, editableStatuses.includes(status) && this.renderEdit()), /*#__PURE__*/React.createElement("td", {
        colSpan: "2"
      }, this.renderViewClorify()));
    }
  }]);
}(Component);
FeedbackHistoryRow.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  proposalResourceId: PropTypes.string.isRequired,
  consultant: PropTypes.shape({}).isRequired,
  clorifyUrl: PropTypes.string.isRequired,
  reasonOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  item: PropTypes.shape({}).isRequired,
  type: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  internalFeedbackText: PropTypes.string,
  advisorRemark: PropTypes.string
};
FeedbackHistoryRow.defaultProps = {
  internalFeedbackText: null,
  advisorRemark: null
};
export default FeedbackHistoryRow;